import { FormikProps } from 'formik'
import React from 'react'
import Select from 'react-select'

interface FormValues {
  gender: string
  birthDate: string
  countryOfBirthName: string
  countryOfBirthCode:string
  street: string
  city: string
  zipCode: string
  occupation: string
  transactionPerMonth: string
  numberTransactionsPerMonth: string
}
interface Props {
  formik: FormikProps <FormValues>
}

type SelectOption = {
  index: number
  code:string
  label: string
}

const ProfileStepThree: React.FC<Props> = ({ formik }) => {
  const ListeProfession: SelectOption[] =[
    { index: 0, code: "Comptable", label: 'Comptable' },
    { index: 1, code: 'Personnel Administratif', label: 'Personnel Administratif' },
    { index: 2, code: 'Ingénieur', label: 'Ingénieur' },
    { index: 3, code: "Professionnel des technologies de l'information", label: "Professionnel des technologies de l'information" },
    { index: 4, code: 'Professionnel de la santé', label: 'Professionnel de la santé' },
    { index: 5, code: 'Professeur', label: 'Professeur' },
    { index: 6, code: 'Technicien', label: 'Technicien' },
    { index: 7, code: 'Autres', label: 'Autres' },
  ]

  const ListeMontantsMensuels: SelectOption[] = [
    { index: 0, code: '1000', label: 'Moins de 1 000 €' },
    { index: 1, code: '5000' , label: '1 000 € – 5 000 €' },
    { index: 2, code: '10000', label: '5 000 € – 10 000 €' },
    { index: 3, code: '50000', label: '10 000 € – 50 000 €' },
    { index: 4, code: '100000', label: 'Plus de 50 000 €' },
  ]

  const ListeNombreTransfertsMensuels: SelectOption[] = [
    { index: 0, code: '5', label: '1 – 5 transactions' },
    { index: 1, code: '10', label: '6 – 10 transactions' },
    { index: 2, code: '25' , label: '11 – 25 transactions' },
    { index: 3, code: '50' , label: '26 – 50 transactions' },
    { index: 4, code: '100' , label: '51 – 100 transactions' },
  ]

  return (
    <div className="flex flex-col sm:items-center gap-4 w-full">
      <h3 className="text-[#AEB6FB] font-bold">Étape 1</h3>

      <div className="flex flex-col gap-1 w-full">
        <label className="h3">Profession </label>
        <Select
          classNamePrefix="select"
          isSearchable={false}
          placeholder="Votre profession"
          options={ListeProfession}
          value={ListeProfession.find((item) => item.code === formik.values.occupation) || null}
          onChange={(option) => formik.setFieldValue('occupation', option?.code || '')}
          onBlur={() => formik.setFieldTouched('occupation', true)}
          getOptionValue={(option) => option.label}
          getOptionLabel={(option) => option.label}
        />

        <p className="text-[#EE443F] text-[10px] h-[15px] sm:h-[10px] ">
          {formik.touched.occupation && formik.errors.occupation}
        </p>
      </div>

      <div className="flex flex-col w-full gap-1">
        <label className="h3">
          Volume mensuel approximatif
          <br /> des transactions (en Euro){' '}
        </label>
        <Select
          classNamePrefix="select"
          isSearchable={false}
          placeholder="Volume des transactions"
          options={ListeMontantsMensuels}
          value={ListeMontantsMensuels.find((item) => item.code === formik.values.transactionPerMonth) || null}
          onChange={(option) => formik.setFieldValue('transactionPerMonth', option?.code || '')}
          onBlur={() => formik.setFieldTouched('transactionPerMonth', true)}
          getOptionValue={(option) => option.label}
          getOptionLabel={(option) => option.label}
        />

        <p className="text-[#EE443F] text-[10px] h-[15px] sm:h-[10px] ">
          {formik.touched.transactionPerMonth && formik.errors.transactionPerMonth}
        </p>
      </div>

      <div className="flex flex-col gap-1 w-full">
        <label className="h3">
          Nombre approximatif de transactions
          <br /> (par Mois){' '}
        </label>
        <Select
          classNamePrefix="select"
          isSearchable={false}
          placeholder="Nombre de transactions"
          options={ListeNombreTransfertsMensuels}
          value={
            ListeNombreTransfertsMensuels.find((item) => 
              item.code === formik.values.numberTransactionsPerMonth) || null
          }
          onChange={(option) => formik.setFieldValue('numberTransactionsPerMonth', option?.code || '')}
          onBlur={() => formik.setFieldTouched('numberTransactionsPerMonth', true)}
          getOptionValue={(option) => option.label}
          getOptionLabel={(option) => option.label}
        />

        <p className="text-[#EE443F] text-[10px] h-[15px] sm:h-[10px] ">
          {formik.touched.numberTransactionsPerMonth && formik.errors.numberTransactionsPerMonth}
        </p>
      </div>
    </div>
  )
}

export default ProfileStepThree
